let apiURL = 'https://api-karaoke.traefik.me';
if (process.env.NODE_ENV === 'production') {
    apiURL = 'https://api.karaoke-kreyol.com';
}

export default apiURL;
